import { render, staticRenderFns } from "./DeviceQuickAction.vue?vue&type=template&id=95f39f8e&scoped=true&"
import script from "./DeviceQuickAction.vue?vue&type=script&lang=js&"
export * from "./DeviceQuickAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95f39f8e",
  null
  
)

export default component.exports